"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Container = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/taggedTemplateLiteral"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _variables = require("../../../global-files/variables");

var _templateObject;

var Container = _styledComponents.default.div(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2.default)(["\n\n  display: flex;\n  background-color: transparent;\n  justify-content:center ;\n\n  .listaGeneral {\n    color: ", ";\n    font-family: ", ";\n    font-style: normal;\n    font-weight: 500;\n    font-size: 18px;\n    line-height: 40px;\n    text-align: left;\n  }\n"])), _variables.GlobalColors.white, _variables.FontFamily.Raleway);

exports.Container = Container;